module.exports = __webpack_public_path__ + "static/media/camera.732006f3.svg";